/*
 * @Author: changcheng
 * @LastEditTime: 2022-10-28 13:58:58
 */
import { useSelector } from "react-redux";
import { RootState } from "@root/store/index";
import { useState } from "react";
import { Table, Modal, Descriptions } from "antd";
import "./_index.scss";
import {
  getVillageWaitReviewedList,
  queryApprovalInfo,
} from "@root/common/service";
import { useEffect } from "react";
const baseAuditStatusArr = ["通过", "审核退回", "未确认"];
const flowTypeArr = ["注册", "调入", "修改"];
interface approvalInfoType {
  baseCenterCategoryList: string;
  baseHealthTitle: string;
  baseUserIdCategory: string;
  birthday: string;
  dataType: string;
  flowId: number;
  id: number;
  identityNumber: string;
  instituteId: number;
  nickName: string;
  sex: string;
  subjectId: number;
}
export default function Approval() {
  const {
    subjectData = [],
    titleData = [],
    instituteList = [],
    centerClassification = [],
  } = useSelector((state: RootState) => state.directionaries);
  const { baseUserCategory, instituteId, userId } = useSelector(
    (state: RootState) => state.userInfo
  );
  const [approvalList, setApprovalList] = useState([]);
  const [approvalInfo, setApprovalInfo] = useState<approvalInfoType[]>([]);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  /**
   * 判断是否是注册类型，用于区分数据展示
   */
  const [isRegisterType, setIsRegisterType] = useState(false);
  const [total, setTotal] = useState(0);
  const queryWaitReviewedList = async (pageNum = 1) => {
    const { rows, total } = await getVillageWaitReviewedList(
      {
        pageNum,
        pageSize: 10,
      },
      baseUserCategory === "12"
        ? `&instituteId=${instituteId}`
        : baseUserCategory === "14"
        ? `&userId=${userId}`
        : ""
    );
    setTotal(total);
    setApprovalList(
      rows.map((item: any, index: number) => {
        return {
          key: item.id,
          index,
          ...item,
        };
      })
    );
  };
  /**
   * 获取审批详情
   * @param id
   */
  const getApprovalInfo = async (id: number) => {
    const { rows = [] } = await queryApprovalInfo(id);
    console.log(rows);

    setShowApprovalModal(true);
    setApprovalInfo(rows);
  };
  useEffect(() => {
    queryWaitReviewedList();
  }, []);
  const columns = [
    {
      title: "序号",
      dataIndex: "index",
      key: "index",
    },
    {
      title: "审核状态",
      dataIndex: "baseAuditStatus",
      key: "baseAuditStatus",
      render: (_: any, record: any) => {
        return <span>{baseAuditStatusArr[_]}</span>;
      },
    },
    {
      title: "审核类型",
      dataIndex: "flowType",
      key: "flowType",
      render: (_: any, record: any) => {
        return <span>{flowTypeArr[_ - 1]}</span>;
      },
    },
    {
      title: "提交审核详情",
      dataIndex: "flowType",
      key: "flowType",
      render: (_: any, record: any) => {
        return (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a
            onClick={() => {
              setIsRegisterType(record.flowType === "1" ? true : false);
              getApprovalInfo(record.id);
            }}
          >
            点击详情
          </a>
        );
      },
    },
    {
      title: "提交时间",
      dataIndex: "updateTime",
      key: "updateTime",
    },
  ];
  const [baseInfo, updateInfo] = approvalInfo;
  // 所在中心数据反显
  function GetbaseCenterCategoryList(
    centerClassification: any[],
    centerList: any[]
  ) {
    console.log("centerClassification", centerClassification);
    console.log("centerList", centerList);

    return centerList
      .map((item) => {
        return centerClassification.find((it) => it.id === Number(item)).name;
      })
      .join(",");
  }
  return (
    <div>
      <Table
        columns={columns}
        dataSource={approvalList}
        pagination={{
          total,
          onChange: (page) => {
            queryWaitReviewedList(page);
          },
          showTotal: (total) => {
            return "共" + total + "条记录";
          },
          showSizeChanger: false,
        }}
      />
      <Modal
        title="审批详情"
        visible={showApprovalModal}
        onOk={() => {
          setShowApprovalModal(false);
        }}
        onCancel={() => {
          setShowApprovalModal(false);
        }}
        width={"auto"}
      >
        {approvalInfo.length > 0 && (
          <Descriptions
            title={`用户信息${isRegisterType ? "" : "(原有/更改)"}`}
            bordered
          >
            <Descriptions.Item
              label="姓名"
              className={
                !isRegisterType && updateInfo.nickName !== null
                  ? "isUpdate"
                  : ""
              }
            >
              {baseInfo.nickName}
              {!isRegisterType &&
                updateInfo.nickName &&
                `->${updateInfo.nickName}`}
            </Descriptions.Item>
            <Descriptions.Item
              label="性别"
              className={
                !isRegisterType && updateInfo.sex !== null ? "isUpdate" : ""
              }
            >
              {baseInfo.sex === "0" ? "男" : "女"}
              {!isRegisterType &&
                updateInfo.sex &&
                `->${updateInfo.sex === "0" ? "男" : "女"}`}
            </Descriptions.Item>
            <Descriptions.Item
              label="证件类型"
              className={
                !isRegisterType && updateInfo.baseUserIdCategory !== null
                  ? "isUpdate"
                  : ""
              }
            >
              {baseInfo.baseUserIdCategory === "0" ? "身份证" : "其他"}
              {!isRegisterType &&
                updateInfo.baseUserIdCategory &&
                `->${
                  updateInfo.baseUserIdCategory === "0" ? "身份证" : "其他"
                }`}
            </Descriptions.Item>
            <Descriptions.Item
              label="证件号码"
              className={
                !isRegisterType && updateInfo.identityNumber !== null
                  ? "isUpdate"
                  : ""
              }
            >
              {baseInfo.identityNumber}
              {!isRegisterType &&
                updateInfo.identityNumber &&
                `->${updateInfo.identityNumber}`}
            </Descriptions.Item>
            <Descriptions.Item
              label="出生日期"
              className={
                !isRegisterType && updateInfo.birthday !== null
                  ? "isUpdate"
                  : ""
              }
            >
              {baseInfo.birthday}
              {!isRegisterType &&
                updateInfo.birthday &&
                `->${updateInfo.birthday}`}
            </Descriptions.Item>
            <Descriptions.Item
              label="职称"
              className={
                !isRegisterType && updateInfo.baseHealthTitle !== null
                  ? "isUpdate"
                  : ""
              }
            >
              {
                titleData.find(
                  (item) => item.id === Number(baseInfo.baseHealthTitle)
                )?.name
              }
              {!isRegisterType &&
                updateInfo.baseHealthTitle &&
                `->${
                  titleData.find(
                    (item) => item.id === Number(updateInfo.baseHealthTitle)
                  )?.name
                }`}
            </Descriptions.Item>
            <Descriptions.Item
              label="所在学科"
              className={
                !isRegisterType && updateInfo.subjectId !== null
                  ? "isUpdate"
                  : ""
              }
            >
              {subjectData.find((item) => item.id === baseInfo.subjectId)?.name}
              {!isRegisterType &&
                updateInfo.subjectId &&
                `->${
                  subjectData.find((item) => item.id === updateInfo.subjectId)
                    ?.name
                }`}
            </Descriptions.Item>
            <Descriptions.Item
              label="所在中心"
              className={
                !isRegisterType && updateInfo.baseCenterCategoryList !== null
                  ? "isUpdate"
                  : ""
              }
            >
              {GetbaseCenterCategoryList(
                centerClassification,
                baseInfo.baseCenterCategoryList.split(",")
              )}
              {!isRegisterType &&
                updateInfo.baseCenterCategoryList &&
                `->${GetbaseCenterCategoryList(
                  centerClassification,
                  updateInfo.baseCenterCategoryList.split(",")
                )}`}
            </Descriptions.Item>
            <Descriptions.Item
              label="所在机构"
              className={
                !isRegisterType && updateInfo.instituteId !== null
                  ? "isUpdate"
                  : ""
              }
            >
              {
                instituteList.find((item) => item.id === baseInfo.instituteId)
                  ?.name
              }
              {!isRegisterType &&
                updateInfo.instituteId &&
                `->${
                  instituteList.find(
                    (item) => item.id === updateInfo.instituteId
                  )?.name
                }`}
            </Descriptions.Item>
          </Descriptions>
        )}
      </Modal>
    </div>
  );
}
